{
  "version": 1,
  "asset_id": "7b7252d8-c075-40c9-bb45-5d0929d41a52",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/7b7252d8-c075-40c9-bb45-5d0929d41a52/bypass-weight-loss-graph-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/7b7252d8-c075-40c9-bb45-5d0929d41a52/bypass-weight-loss-graph-480.webp",
  "original_filename": "bypass-weight-loss-graph-480.webp",
  "size": 7120,
  "content_type": "image/webp",
  "created_at": "2026-10-04T16:12:44Z"
}
